import React, { useState, useEffect } from "react";
import axios from "axios";
import Clock from "../../img/Clock";
import Info from "../../img/Info";
import BackButton from "../../components/BackButton/BackButton";
import "./styles.css";
import Button from "../../components/Button/Button";

function OfferByDays({
  model,
  selectedStorage,
  grade,
  onOfferSelect,
  onBack,
  batteryLevel,
}) {
  const [offers, setOffers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null); // Para guardar la oferta seleccionada en el popup
  const [priceDifference, setPriceDifference] = useState(0); // Guardar la diferencia de precio

  useEffect(() => {
    console.log(batteryLevel);
    axios
      .get(
        `https://api.quieromac.com/retomas/inventory/celucambio/price?product_id=${model.id}&quality_id=${grade}&storage_id=${selectedStorage.storage_id}&battery_level=${batteryLevel}`
      )
      .then((response) => {
        setOffers(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [model.id, grade, selectedStorage.storage_id]);

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (error) {
    return <p>Hubo un error al cargar las ofertas.</p>;
  }

  const formatPrice = (price) => {
    if (price === undefined || isNaN(price)) return "No disponible";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleOfferClick = (paymentPeriod, price, productId) => {
    const priceDiff = offers.price_60_days - price; // Calcular la diferencia de precio
    if (paymentPeriod !== 60) {
      // Mostrar el popup de confirmación para las ofertas que no sean la primaria
      setSelectedOffer({ paymentPeriod, price, productId });
      setPriceDifference(priceDiff); // Guardar la diferencia de precio
      setShowConfirmation(true);
    } else {
      // Si es la oferta primaria, sigue el flujo normal
      onOfferSelect(paymentPeriod, price, productId);
    }
  };

  const confirmOffer = () => {
    const { paymentPeriod, price, productId } = selectedOffer;
    onOfferSelect(paymentPeriod, price, productId);
    setShowConfirmation(false); // Cierra el popup después de confirmar
  };

  const cancelOffer = () => {
    setShowConfirmation(false); // Cierra el popup sin confirmar
  };

  const priceDifference30Days = offers.price_30_days - offers.price;
  const priceDifference60Days = offers.price_60_days - offers.price;

  return (
    <div className="OfferByDays">
      <h1>Selecciona el tiempo de pago</h1>
      <p className="description">
        Elige cuándo quieres recibir el pago por tu dispositivo. Ten en cuenta
        que el valor de retoma puede variar según el tiempo que elijas.
      </p>
      <div className="offersContainer">
        <div
          className="individualOffer"
          onClick={() => handleOfferClick(1, offers.price, offers.product_id)}
        >
          <Clock width="24" height="24" />
          <div className="leftSideOffer">
            <div>
              <p className="subtitleOffer">Pago en 3 hábiles</p>
              <p className="subsubtitleOffer">
                Espera 3 dias habiles para que podamos revisar el estado de tu
                dispositivo y realizar el traspaso de manera segura
              </p>
            </div>
            <div className="leftPrice">
              <p className="priceOffer">${formatPrice(offers.price)}</p>
            </div>
          </div>
        </div>
        <div
          className="individualOffer"
          onClick={() =>
            handleOfferClick(30, offers.price_30_days, offers.product_id)
          }
        >
          <Clock width="24" height="24" />
          <div className="leftSideOffer">
            <div>
              <p className="subtitleOffer">Pago a 30 días hábiles</p>
              <p className="subsubtitleOffer">Espera un mes, gana más</p>
            </div>
            <div className="leftPrice">
              <p className="priceOffer">${formatPrice(offers.price_30_days)}</p>
              <p className="addPrice">+${formatPrice(priceDifference30Days)}</p>
            </div>
          </div>
        </div>
        <div
          className="individualOffer primary"
          onClick={() =>
            handleOfferClick(60, offers.price_60_days, offers.product_id)
          }
        >
          <Clock width="48" height="48" />
          <div className="leftSideOffer">
            <div>
              <p className="subtitleOffer">Pago a 60 días hábiles</p>
              <p className="subsubtitleOffer">Maximiza tus ganancias</p>
            </div>
            <div className="leftPrice">
              <p className="priceOffer big">
                ${formatPrice(offers.price_60_days)}
              </p>
              <p className="addPrice">+${formatPrice(priceDifference60Days)}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="infoContainer">
        <Info />
        <div className="hoverContainer">
          <p className="hoverTrigger">
            Recuerda que el valor de tu equipo puede variar si no cumple con las
            condiciones funcionales y cosméticas indicadas al momento de la
            valoración
          </p>
          <p className="hoverContent">
            <strong>Términos y Condiciones de Valoración de Equipos</strong>
            <br />
            <br />
            1.⁠ ⁠<strong>Generalidades:</strong> <br />
            Al momento de realizar la valoración de tu equipo, se considerarán
            diversos aspectos funcionales y cosméticos. La oferta presentada en
            dicha valoración inicial es referencial y puede estar sujeta a
            cambios si se detectan condiciones que no correspondan con la
            descripción proporcionada por el usuario.
            <br />
            <br />
            2.⁠ ⁠<strong>Valoración del Equipo:</strong> <br />
            El valor estimado de tu equipo se basa en las siguientes
            condiciones:
            <br />
            <ul>
              <li>
                <strong>Condición funcional:</strong> El equipo debe estar en
                pleno funcionamiento, sin fallas técnicas en hardware o
                software.
              </li>
              <li>
                <strong>Condición cosmética:</strong> El equipo debe presentar
                un buen estado físico, sin daños estéticos graves, tales como
                roturas, grietas o desgaste extremo.
              </li>
            </ul>
            <br />
            3.⁠ ⁠<strong>Revisión y Ajuste del Valor:</strong> <br />
            El equipo será sometido a una inspección técnica y visual para
            verificar que coincida con las condiciones indicadas por el usuario
            en el momento de la valoración inicial. Si se encuentra que el
            equipo no cumple con las condiciones previamente descritas, nos
            reservamos el derecho a modificar el valor ofrecido o rechazar la
            operación. Las principales razones para una variación en el valor
            del equipo incluyen, pero no se limitan a:
            <ul>
              <li>
                Daños físicos no informados (pantallas rotas, abolladuras,
                desgaste excesivo).
              </li>
              <li>
                Fallas en el funcionamiento de componentes claves (batería,
                pantalla, cámara, puertos, entre otros).
              </li>
              <li>
                Equipos bloqueados o con restricciones que impidan su uso
                normal.
              </li>
            </ul>
            <br />
            4.⁠ ⁠<strong>Aceptación del Nuevo Valor:</strong> <br />
            En caso de que el valor de tu equipo varíe tras la revisión, te
            notificaremos con el nuevo monto a ofrecer. Tendrás la opción de
            aceptar el nuevo valor o rechazarlo. Si decides no aceptar, el
            equipo será devuelto sin costo alguno.
            <br />
            <br />
            5.⁠ ⁠<strong>Política de Devolución:</strong> <br />
            Si rechazas la oferta ajustada, nos comprometemos a devolver tu
            equipo en el mismo estado en que fue recibido, sin que se generen
            costos adicionales para ti.
            <br />
            <br />
            6.⁠ ⁠<strong>Legislación Aplicable:</strong> <br />
            Estos Términos y Condiciones están sujetos a la normativa vigente en
            Colombia, incluyendo, pero no limitado a, la Ley 1480 de 2011
            (Estatuto del Consumidor), que regula los derechos de los
            consumidores en el país.
          </p>
        </div>
      </div>

      <div className="infoContainer">
        <Info />
        <p>
          Esperar 60 días para recibir el pago te permite obtener el máximo
          valor por tu dispositivo. Aprovecha esta oportunidad para maximizar
          tus ganancias.
        </p>
      </div>
      <div className="waitSection">
        <p>
          <b>¿Por qué esperar 60 días?</b>
        </p>
        <ul>
          <li>Obtén hasta un 10% más de valor por tu dispositivo</li>
          <li>Tiempo para preparar tu nuevo dispositivo</li>
          <li>Flexibilidad para planificar tu presupuesto</li>
          <li>
            <b>Testimonio:</b> "Esperé 60 días y obtuve $200.000 más.
            ¡Totalmente vale la pena!" - María C.
          </li>
        </ul>
      </div>
      <BackButton onClick={onBack} />

      {/* Popup de confirmación */}
      {showConfirmation && (
        <div className="popupOf">
          <div className="popupContent">
            <p className="subtitleOffer">¿Estás seguro?</p>
            <p className="subsubtitleOffer">
              Al elegir esta opción, estás dejando de ganar hasta $
              {formatPrice(priceDifference)} adicionales. Te recomendamos
              considerar la opción de 60 días para maximizar el valor de tu
              dispositivo.
            </p>
            <div className="popupButtons">
              <Button type="full" onClick={cancelOffer}>
                Reconsiderar
              </Button>
              <Button type="fullBlack" onClick={confirmOffer}>
                Confirmar selección
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OfferByDays;
